import { render, staticRenderFns } from "./BrazilMap.vue?vue&type=template&id=47e1c804&scoped=true"
import script from "./BrazilMap.vue?vue&type=script&lang=js"
export * from "./BrazilMap.vue?vue&type=script&lang=js"
import style0 from "./BrazilMap.vue?vue&type=style&index=0&id=47e1c804&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1c804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e1c804')) {
      api.createRecord('47e1c804', component.options)
    } else {
      api.reload('47e1c804', component.options)
    }
    module.hot.accept("./BrazilMap.vue?vue&type=template&id=47e1c804&scoped=true", function () {
      api.rerender('47e1c804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/BrazilMap.vue"
export default component.exports